export default "__VITE_ASSET__14ad9a2d__"